import React from "react";
import { Carousel, Card } from "../components/ui/apple-cards-carousel";

export function AppleCardsCarouselDemo() {
  const cards = data.map((card, index) => (
    <Card key={card.src} card={card} index={index} />
  ));

  return (
    <div className="w-full h-full py-20">
      <h2 className="max-w-7xl pl-4 mx-auto text-xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 font-sans">
        Discover the Essence of Beyond Bloom
      </h2>
      <Carousel items={cards} />
    </div>
  );
}

const DummyContent = () => {
  return <>{[...new Array(3).fill(1)].map((_, index) => {})}</>;
};

const data = [
  {
    category: "Our Vision",
    title: "Beyond Bloom – Redefining Excellence",
    src: "/images/slider/07.jpg",
    content:
      "At Beyond Bloom, we are committed to pushing the boundaries of quality, sustainability, and innovation to deliver products that enhance everyday life.",
  },
  {
    category: "Product Excellence",
    title: "Crafted for Perfection",
    src: "/images/slider/01.jpg",
    content:
      "Our products undergo rigorous quality checks, ensuring durability, functionality, and an unmatched experience for our customers.",
  },
  {
    category: "Sustainability",
    title: "Eco-Friendly, Future-Ready",
    src: "/images/slider/02.jpg",
    content:
      "We prioritize eco-conscious materials and processes, reducing our environmental footprint while maintaining premium product standards.",
  },
  {
    category: "Innovation",
    title: "Designed to Inspire",
    src: "/images/slider/03.jpg",
    content:
      "Beyond Bloom continuously innovates, blending cutting-edge technology with timeless design to create truly transformative products.",
  },
  {
    category: "Customer Commitment",
    title: "Your Satisfaction, Our Priority",
    src: "/images/slider/04.jpg",
    content:
      "We value our customers and strive to provide unparalleled service, ensuring every Beyond Bloom experience is seamless and rewarding.",
  },
  {
    category: "Join Us",
    title: "Be a Part of the Beyond Bloom Journey",
    src: "/images/slider/06.jpg",
    content:
      "Passionate about innovation and quality? Explore career opportunities with us and be part of a company that’s shaping the future.",
  },
];
